import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  textAlertSettingsContainer: {
    display: 'flex',
    flex: '1',
    padding: '0px',
    '@media (min-width: 640px)': {
      padding: '16px 24px',
    },
    backgroundColor: theme.evPalette.charcoal[100],
  },
  textAlertSettingsPaper: {
    display: 'flex',
    flex: '1 1 auto',
    flexDirection: 'column',
    borderRadius: '0px',
    padding: '0px',
    '@media (min-width: 640px)': {
      borderRadius: '4px',
    },
  },
  textAlertPhoneContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    width: '100%',
    padding: '16px 24px',
    borderBottom: `1px solid ${theme.evPalette.charcoal[300]}`,
    '@media (min-width: 640px)': {
      borderRadius: '4px',
    },
  },
  phoneInputContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    flex: 1,
    '@media (min-width: 640px)': {
      flexDirection: 'row',
    },
  },
  textAlertMessageContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    width: '100%',
    padding: '16px 24px',
    borderBottom: `1px solid ${theme.evPalette.charcoal[300]}`,
  },
  textAlertDeliveryContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    width: '100%',
    padding: '16px 24px',
    borderBottom: `1px solid ${theme.evPalette.charcoal[300]}`,
  },
  deliveryStatusTypesContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  carrierMessageContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    padding: '16px 24px',
  },
  messageAndButtonsContainer: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    flexDirection: 'column',
  },
  fieldContainer: {
    width: '100%',
    maxWidth: '386px',
  },
  mobileProvidersSelectField: {
    height: '44px',
    maxWidth: '386px',
  },
  paper: {
    height: '324px',
  },
  phoneInputText: {
    maxWidth: '386px',
    height: '44px',
    '&>.myev-MuiInputBase-root': {
      height: '100%',
    },
  },
  inputLabel: {
    maxWidth: '386px',
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,
  },
  checkChangesContainer: {
    gap: '10px',
  },
  textAlertCheckbox: {
    padding: '0px',
  },
  textAlertCheckboxLabel: {
    color: theme.evPalette.charcoal[900],
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '18px',
    letterSpacing: '0px',
  },
  redirectionButtonStyles: {
    color: theme.evPalette.ocean[600],
    fontSize: '12px',
    fontWeight: 400,
    padding: '0px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 'fit-content',
    padding: '16px 24px',
    gap: '16px',
    '@media (min-width: 640px)': {
      flexDirection: 'row',
    },
  },
  saveButton: {
    padding: '10px 16px',
    width: '100%',
    '@media (min-width: 640px)': {
      width: 'auto',
    },
  },
  cancelButton: {
    padding: '10px 16px',
    width: '100%',
    '@media (min-width: 640px)': {
      width: 'auto',
    },
  },
}));
